import z from 'zod';
export const attachmentSchema = z.object({
    id: z.number().optional(),
    name: z.string('Name is required').min(1, 'Name is required').max(255),
    filename: z.string('Filename is required').min(1, 'Filename is required').max(255),
});
export const attachmentGetPutSignedUrlSchema = z.object({
    id: z.number().optional(),
    name: z.string().min(1, 'Name is required').max(255),
});
